import { Button, ButtonProps } from '../../../button/Button';

export function UnSubscribeButton(props: Partial<ButtonProps>) {
  return (
    <Button dataId='unsubscribe-cta' palette='error' variation='outline' size='sm' {...props}>
      Unsubscribe
    </Button>
  );
}
